import { render } from "./DashBoard.vue?vue&type=template&id=6c43dffe&ts=true"
import script from "./DashBoard.ts?vue&type=script&lang=ts"
export * from "./DashBoard.ts?vue&type=script&lang=ts"

import exportComponent from "D:\\bms_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__